<section class="rcx-table" [formGroup]="accessRevocationForm">
  <div class="row">
    <div class="col-lg-12">
      <div class="card btr">
        <div class="card-content">
          <div class="card-body">
            <div class="row">
              <div class="row g-3">
                <div class="col-md-3">
                  <label class="form-label">Applicable <b class="text-secondary">*</b></label>
                  <div class="d-flex align-items-center">
                    <div class="form-check form-check-inline">
                      <input class="form-check-input" type="radio" id="yesOption" name="applicable" [value]="true"
                        formControlName="accessRevoked" [disabled]="context.persona === 'EMPLOYEE'" />
                      <label class="form-check-label" for="yesOption">Yes</label>
                    </div>
                    <div class="form-check form-check-inline">
                      <input class="form-check-input" type="radio" id="noOption" name="applicable" [value]="false"
                        [disabled]="context?.persona === 'EMPLOYEE'" formControlName="accessRevoked"
                        (change)="setAccessRevocation(undefined)" />
                      <label class="form-check-label" for="noOption">No</label>
                    </div>
                    <div
                      *ngIf="accessRevocationForm.get('accessRevoked')?.invalid && (accessRevocationForm.get('accessRevoked')?.dirty || accessRevocationForm.get('accessRevoked')?.touched)">
                      <small class="text-danger"
                        *ngIf="accessRevocationForm.get('accessRevoked').errors?.required">Please select an
                        access revoked</small>
                    </div>
                  </div>
                </div>
                <div class="col-md-3">
                  <label for="revokedByName" class="form-label">Access Revoked By<b class="text-secondary">*</b></label>
                  <div class="input-group">
                    <span class="input-group-text bg-transparent border-end-0"><i class='bx bx-repost'></i></span>
                    <ng-select class="form-control rcx-ng-select" formControlName="revokedById"
                      placeholder="Select a revoked by name" [ngClass]="{'is-invalid': submitted && s.id.errors}"
                      [readonly]="context.persona === 'EMPLOYEE'">
                      <ng-option *ngFor="let revokedBy of revokes" [value]="revokedBy.employeeData.id">
                        {{ revokedBy?.employeeData.name }}
                      </ng-option>
                    </ng-select>
                  </div>
                  <div
                    *ngIf="accessRevocationForm.get('revokedById')?.invalid && (accessRevocationForm.get('revokedById')?.dirty || accessRevocationForm.get('revokedById')?.touched)">
                    <small class="text-danger" *ngIf="accessRevocationForm.get('revokedById').errors?.required">Please
                      select an
                      access revoked by</small>
                  </div>
                </div>
                <div class="col-md-3">
                  <label for="revokedAt" class="form-label">Revoked Date<b class="text-secondary">*</b></label>
                  <div class="input-group"> <span class="input-group-text bg-transparent  border-end-0"><i
                        class='bx bx-calendar'></i></span>
                    <input type="date" class="form-control ps-1" id="revokedAt" formControlName="revokedAt"
                      [readonly]="context.persona === 'EMPLOYEE'" />
                  </div>
                  <div
                    *ngIf="accessRevocationForm.get('revokedAt')?.invalid && (accessRevocationForm.get('revokedAt')?.dirty || accessRevocationForm.get('revokedAt')?.touched)">
                    <small class="text-danger" *ngIf="accessRevocationForm.get('revokedAt').errors?.required">Please
                      select an access revoked date.</small>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>